import { Store } from "#/store";

export function getTranslatedImage(imageObject, language, size) {
  let languageOrder = [language, "en", "de"];
  for (let index = 0; index < languageOrder.length; ++index) {
    let lang = languageOrder[index];

    if (
      imageObject &&
      imageObject[lang] &&
      imageObject[lang]["full"] &&
      imageObject[lang]["full"].toLowerCase().endsWith("svg")
    ) {
      if (imageObject[lang]["full"].split("/").length > 5) {
        return imageObject[lang]["full"];
      } else {
        return Store.instance.page.page!.s3Url + imageObject[lang]["full"];
      }
    }
    // Check for normal images and size
    else if (imageObject && imageObject[lang] && imageObject[lang][size]) {
      if (imageObject[lang][size].split("/").length > 5) {
        return imageObject[lang][size];
      } else {
        return Store.instance.page.page!.s3Url + imageObject[lang][size];
      }
    }
  }

  return null;
}

export function getTranslatedImageSize(imageObject, language) {
  let languageOrder = [language, "en", "de"];
  for (let index = 0; index < languageOrder.length; ++index) {
    let lang = languageOrder[index];

    if (imageObject[lang] && imageObject[lang]["file_size"]) {
      return imageObject[lang]["file_size"];
    }
  }

  return null;
}

export function getTranslatedImageType(imageObject, language) {
  let languageOrder = [language, "en", "de"];
  for (let index = 0; index < languageOrder.length; ++index) {
    let lang = languageOrder[index];

    if (imageObject[lang] && imageObject[lang]["file_type"]) {
      return imageObject[lang]["file_type"];
    }
  }

  return null;
}
